<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page">
            <div class="formularios-list vertical-flow">
                <h1 class="title">{{ $t('formularios') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a> {{ isPromotor ? $t('promotor') : $t('vendas') }}</a>
                        </li>
                        <li>
                            <a> {{ isPromotor ? $t('relatorios') : $t('formulario') }}</a>
                        </li>
                        <li>
                            <a href="#" aria-current="page">{{ $t('formularios') }}</a>
                        </li>
                    </ul>
                </nav>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar :onSearch="debouncedOnSearch" />
                    </div>
                </div>

                <div class="registry-wrapper">
                    <b-table :data="formularios" :mobile-cards="false" class="data-table">
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'titulo'">
                                <router-link
                                    :to="{
                                        name: isPromotor
                                            ? 'formulario-respondido-consulta-edit'
                                            : 'ven-formulario-respondido-consulta-edit',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    {{ props.row[f.key] }}
                                </router-link>
                            </div>
                        </b-table-column>
                    </b-table>
                    <b-pagination
                        :total="totalRows"
                        :current.sync="currentPage"
                        :per-page="perPage"
                        :order="'is-centered'"
                        @change="carregarFormularios"
                    >
                    </b-pagination>
                    <!-- <b-table responsive :items="formularios" :fields="fields" :current-page="currentPage" :per-page="perPage" :stripped="true" :hover="true">
                        <span slot="cor" slot-scope="data" v-html="data.value"></span>
                        <template slot="titulo" slot-scope="val">
                            <router-link :to="{name : 'formulario-respondido', params: { id : val.item.id }}">
                                {{val.value}}
                            </router-link>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col md="6" class="my-1">
                            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
                        </b-col>
                    </b-row> -->
                </div>
                <!-- <router-link class="btn footer-btn" type="button" tag="button" :to="{ name: 'new-formulario' }" >
                    <span class="icon">+</span>
                </router-link>  -->
            </div>
        </div>
    </div>
</template>

<script>
import FilterBar from '@/components/shared/Filter';
import FormularioService from '@/services/FormularioService';

export default {
    components: {
        FilterBar,
    },
    data() {
        return {
            formularios: [],
            service: null,
            sURL: null,
            fields: [
                { key: 'titulo', sortable: true },
                // { key: "titulo", label: this.$t("titulo"), sortable: true },
                // { key: "respondido-por", label: this.$t("respondente"), sortable: true },
                // { key: "lps", label: this.$t("lps"), sortable: true },
                // { key: "dataatendimento", label: this.$t("data-atendimento"), sortable: true },
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            pageOptions: [5, 10, 15],
            isLoading: false,
            debouncedOnSearch: null,
            permissao: {},
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
        };
    },
    created() {
        if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'relatorios',
                'formulario-respondido-consulta'
            );
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'formulario',
                'ven-formulario-respondido-consulta'
            );
        }

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'formularios' },
            });

        this.service = new FormularioService(this.$http, this.$router);
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarFormularios();
    },
    methods: {
        onSearch(value) {
            this.searchQuery = value;
            this.carregarFormularios(1);
        },
        carregarFormularios(currentPage = 1) {
            this.isLoading = true;
            this.service
                .findAllAnswered(currentPage - 1, this.perPage, this.searchQuery)
                .then(this.mapItems)
                .then((formularios) => {
                    this.formularios = formularios;
                    this.totalRows = this.formularios.length;
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            let formularios = body.content.map((f) => {
                return {
                    id: f.idformulario,
                    titulo: f.titulo,
                    descricao: f.descricao,
                    'respondido-por': f.usuario.nome,
                    // lps: f.lps.nome,
                    // dataatendimento: new Date(f.dataatendimento).toLocaleDateString('pt-BR', {timeZone: 'UTC'} ),
                };
            });
            return formularios;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
    .formularios-list .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .formularios-list .search-and-filter .search-bar {
        width: 100%;
    }
    .formularios-list .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
